import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isAdmin = ['admin', 'administrator'].includes(currentUser.role);
  const effectiveStatus = currentUser.effective_account_status || currentUser.account_status;
  if (!isAdmin && ['expired', 'locked'].includes(effectiveStatus)) {
    const expiredAt = currentUser.expires_at
      ? new Intl.DateTimeFormat('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(currentUser.expires_at))
      : 'da qua han';
    const locked = effectiveStatus === 'locked';

    return (
      <main style={{ alignItems: 'center', background: '#f5f8fc', display: 'flex', minHeight: '100vh', justifyContent: 'center', padding: 24 }}>
        <section style={{ background: '#fff', border: '1px solid #d9e3ef', borderRadius: 12, boxShadow: '0 20px 60px rgba(20,44,84,.12)', maxWidth: 560, padding: 32, textAlign: 'center' }}>
          <span style={{ background: locked ? '#fff1ef' : '#fff2df', borderRadius: 999, color: locked ? '#9b2f24' : '#b46200', display: 'inline-flex', fontSize: 12, fontWeight: 800, marginBottom: 16, padding: '7px 12px' }}>{locked ? 'Tai khoan dang bi khoa' : 'Tai khoan het han'}</span>
          <h1 style={{ color: '#152577', fontSize: 30, margin: '0 0 12px' }}>{locked ? 'Tai khoan hoc tap dang bi khoa' : 'Tai khoan hoc tap da het han'}</h1>
          <p style={{ color: '#53627b', fontSize: 15, lineHeight: 1.6, margin: '0 0 24px' }}>
            {locked ? 'Vui long lien he Trung tam Sao Viet de duoc mo khoa tai khoan.' : `Goi hoc cua ban da ket thuc vao ngay ${expiredAt}. Vui long lien he Trung tam Sao Viet de gia han va tiep tuc luyen tap.`}
          </p>
          <button onClick={logout} type="button" style={{ background: '#152577', border: 0, borderRadius: 8, color: '#fff', cursor: 'pointer', fontWeight: 800, minHeight: 44, padding: '0 18px' }}>Dang xuat</button>
        </section>
      </main>
    );
  }

  return children;
};

export default ProtectedRoute;
